import AOS from 'aos';

const initAos = () => {
	AOS.init({
		once: true,
		duration: 1000,
		disable: 'mobile',
	});
};

import { Modal, Ripple, initTE } from 'tw-elements';
import { heroSlider } from './modules/heroSlider';
import { initLightbox } from './modules/lightbox';
import { initContact } from './modules/contact';
import { initSearch } from './modules/search';
import { initNews } from './modules/news';
import { initShop } from './modules/shop';
import { initProduct } from './modules/product';
import { initYoutube } from './modules/youtube';

initTE({ Modal, Ripple });

document.addEventListener(
	'DOMContentLoaded',
	() => {
		initShop();
		initProduct();
		initLightbox();
		initSearch();
		initAos();
		heroSlider();
		initContact();
		initYoutube();
		initNews({ onUpdate: () => AOS.refreshHard() });
	},
	false
);
